import { VariantElements } from "@/context/VariantContext";
import HeaderNew from "@/HeaderNew";
import HomeNew from "../HomeNew";
import Form from "./Form";
import ResultMobile from "./ResultMobile";

const MobileVariant: Partial<VariantElements> = {
    name: "Mobile",
    headerElement: HeaderNew,
    homeElement: HomeNew,
    formElement: Form,
    resultsElement: ResultMobile,

//    question_checkbox: undefined,
//    question_dropdown: undefined,
//    "question_checkbox-image": undefined,
//    question_image: undefined,
//    question_switch: undefined
}

export default MobileVariant;